import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import isUndefined from 'lodash/isUndefined';
import i18next from 'i18next';
import isHttpError from '../util/isHttpError';
import isNetworkError from '../util/isNetworkError';
import createErrorResponse from '../util/createErrorResponse';

var resolveCorrelationId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
    var errorResponse, correlationId, t;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!isHttpError(error) || isNetworkError(error))) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            errorResponse = createErrorResponse(error);

            if (!(errorResponse.getStatus() < 500 && errorResponse.getStatus() !== 401 && errorResponse.getStatus() !== 403 && errorResponse.getStatus() !== 409)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", null);

          case 5:
            correlationId = errorResponse.getHeaders()['paysera-correlation-id'];

            if (!isUndefined(correlationId)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", null);

          case 8:
            _context.next = 10;
            return i18next.loadNamespaces('error-message-resolver');

          case 10:
            t = i18next.getFixedT(null, 'error-message-resolver');
            return _context.abrupt("return", t('error_code', {
              correlationId: correlationId
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolveCorrelationId(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default resolveCorrelationId;